import { useCallback, useEffect } from 'react';
import { Box, MenuItem, InputLabel, FormControl, Select } from '@mui/material';
import { SCUIButton, SCUINoRecordComponent } from '@/atomic/atoms';
import { useTranslation } from 'react-i18next';
import { CargoQuery } from '@/services/query';
import { MPODC } from '../mpPaymentOnDeliveryCommission.classes';

export const CompanyFilter = ({
    setIsLoading,
    setFilterCompanyId,
    filterCompanyId,
    fetchList,
    setCompanyList,
    companyList,
}: {
    setIsLoading: (isLoading: boolean) => void;
    setFilterCompanyId: (filterCompanyId: number) => void;
    filterCompanyId: number;
    fetchList: () => void;
    setCompanyList: (companyList: any) => void;
    companyList: any;
}) => {
    const { t } = useTranslation();

    const getCompanies = useCallback(() => {
        setIsLoading(true);
        CargoQuery.CompanyList()
            .then((res: any) => {
                setCompanyList(res?.data || []);
            })
            .catch(() => setCompanyList([]))
            .finally(() => setIsLoading(false));
    }, [t]);

    useEffect(() => {
        getCompanies();
    }, []);

    return (
        <Box className={MPODC.companyFilterOuter} sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Box className={MPODC.companyFilterPaper} sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, width: 420 }}>
                <SCUINoRecordComponent />
                <FormControl className={MPODC.companyFilterCompanyField} fullWidth>
                    <InputLabel id="filter-company-label">
                        {t('mpPaymentOnDeliveryCommission.selectCargoCompany')}
                    </InputLabel>
                    <Select
                        className={MPODC.inputSelectCompanyFilter}
                        labelId="filter-company-label"
                        label={t('mpPaymentOnDeliveryCommission.selectCargoCompany')}
                        value={filterCompanyId}
                        onChange={(e) => setFilterCompanyId(Number(e.target.value))}
                    >
                        <MenuItem value={-1}>{t('mpPaymentOnDeliveryCommission.selectCargoCompany')}</MenuItem>
                        {(companyList || []).map((opt: any) => (
                            <MenuItem key={opt.id} value={opt.id}>
                                {opt.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <SCUIButton
                    className={MPODC.inputButtonCompanyFilter}
                    text={t('general.filter')}
                    type="primary"
                    disabled={filterCompanyId === -1}
                    sizeType="fixed"
                    size={'m'}
                    onClick={fetchList}
                />
            </Box>
        </Box>
    );
};
